import { inject } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { CanActivateFn, Router } from '@angular/router';
import { AuthStore } from '@doctor-scheduling/web/state';
import { filter, map, of, switchMap, take } from 'rxjs';

/**
 * Allows access only when the user is not authenticated; otherwise redirects to dashboard.
 * Retries session restore when a refresh token exists so a brief API restart does not
 * strand the user on the login screen.
 * @returns Observable that emits true when logged out, or a dashboard UrlTree
 */
export const noAuthGuard: CanActivateFn = () => {
  const authStore = inject(AuthStore);
  const router = inject(Router);

  return toObservable(authStore.isInitialized).pipe(
    filter((ready) => ready),
    take(1),
    switchMap(() => {
      if (authStore.isAuthenticated()) {
        return of(router.createUrlTree(['/dashboard']));
      }
      return authStore.ensureSession().pipe(
        map((ok) => (ok ? router.createUrlTree(['/dashboard']) : true))
      );
    })
  );
};
